export const UNSUBSCRIBE_MODE_MONITOR = 1;
export const UNSUBSCRIBE_MODE_ALL = 2;

export const getConfirmDeletionUrl = (token: string): string => `/api/v1/users/confirm-deletion/${token}`;

export const clearStoredAuthTokens = (): void => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    sessionStorage.removeItem('accessToken');
    sessionStorage.removeItem('refreshToken');
};
